<script setup lang="ts">
import { IDEVIEWMODELS } from '@/utils/models'

import { changeLogArray } from '@/utils/ideBoardingSteps'

import settingService from '@/services/ide/settings/setting.service'
import boardingService from '@/services/boarding.service'

import ideModal from '@/components/ide/ide/IdeModal.vue'

/**
 * @description - initiating the steps
 */
const handleBoardingStarted = async () => {
  settingService.closePopup(IDEVIEWMODELS.CHANGELOG)
  boardingService.initializedBoardingSteps()
}

/**
 * @description -skipping the steps and closing the modal
 */
const skipChangeLog = () => {
  settingService.closePopup(IDEVIEWMODELS.CHANGELOG)
  boardingService.updateBoardingStatus(null, true)
}
</script>
<template>
  <ideModal :isHeaderHidden="true" class="my-auto !w-full max-w-full sm:max-w-sm">
    <div class="mb-2 flex w-full flex-col gap-3 p-2">
      <div class="text-high text-start text-base font-semibold">
        Explore what’s new at JDoodle ✨
      </div>
      <div class="text-mid text-xs font-normal">
        Take a quick tour of our exciting new features in 60 seconds. You can skip anytime.
      </div>
    </div>
    <div class="mb-4 flex w-full flex-col p-2">
      <div v-for="(data, index) of changeLogArray" :key="index" class="flex w-full flex-col gap-1">
        <div class="text-high text-sm font-semibold">{{ data.header }}</div>
        <ul>
          <li
            v-for="(dataDesc, index) of data.desc"
            :key="index"
            v-html="dataDesc"
            class="text-mid mt-3 list-disc text-xs font-normal"
          ></li>
        </ul>
      </div>
    </div>
    <div class="mt-2 flex w-full items-center justify-between">
      <button
        class="text-mid stroke-primary-default rounded border px-2 py-1 text-sm"
        @click="skipChangeLog"
      >
        Skip tour
      </button>
      <button
        class="text-high rounded border border-black px-2 py-1 text-sm dark:border-white"
        @click="handleBoardingStarted"
      >
        Let's go <FontAwesomeIcon icon="fa-arrow-right" class="text-high px-1 text-xs" />
      </button>
    </div>
  </ideModal>
</template>
<style>
.scoped-class .boarding-popover-title {
  font-size: 16px !important;
  font-style: normal !important;
  font-weight: 600 !important;
  color: #0a2540 !important;
  display: flex !important;
  justify-content: space-between;
  width: 100% !important;
}
.scoped-class .boarding-popover-title .step-number {
  font-size: 12px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  color: #7387a9 !important;
  text-wrap: nowrap !important;
}
.scoped-class .boarding-popover-description {
  font-size: 12px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  color: #4b5f7f !important;
  line-height: 18px !important;
  padding-bottom: 6px !important;
  padding-top: 6px !important;
}
.scoped-class .boarding-popover-footer .boarding-btn-group {
  display: flex !important;
  gap: 8px !important;
}
.scoped-class .boarding-popover-footer .boarding-btn-group button {
  border: 1px solid #d0dcf0 !important;
  background-color: #fff !important;
  border-radius: 4px !important;
}
.scoped-class .boarding-popover-footer .boarding-close-btn {
  border: 1px solid #d0dcf0 !important;
  background-color: #fff !important;
  border-radius: 4px !important;
}
</style>
